export const portalProjectStatuses = {
	active: 'ACTIVE',
	inactive: 'INACTIVE',
};

export const portalSearchQueries = {
	task: 'task',
	milestone: 'milestone',
	folder: 'folder',
};

export const tabsNames = {
	tasks: 'Tasks',
	milestones: 'Milestones',
	timeline: 'Timeline',
	files: 'Files',
};

export const getTabs = () => [
	{
		title: tabsNames.tasks,
		value: tabsNames.tasks,
		isVisible: true,
	},
	{
		title: tabsNames.milestones,
		value: tabsNames.milestones,
		isVisible: true,
	},
	{
		title: tabsNames.timeline,
		value: tabsNames.timeline,
		isVisible: true,
	},
	{
		title: tabsNames.files,
		value: tabsNames.files,
		isVisible: true,
	},
];

export const editIconTooltip = 'Edit project';

export const editIconDisabledTooltip = 'Inactive projects cannot be edited';

export const backPagePath = '/admin-panel/portal-projects';
